export class Employee {
  id: number;
  emailId: string;
  mobileNo: number;
  employeeId: string;
}

export class Offer {
  id: number;
  code: string;
  used: boolean;
  max: number;
  available: number;
  startDt: number;
  endDt: number;
  program: string;
}
export class code{
  code:String;
  date:String
}

export class EPResponse {
  status: string;
  desc: string;
  employee: Employee;
  offers: Offer[];
  code:code[];
  otp: string;
  codeCount:number;
  familyDetails: Family[];
  slotsAvailable: number;
  totalSlots: number
}

export class Family {
  name: string;
  mobileNo: number;
  canDelete: boolean = true;
}

export class EmployeeValidationData {
  emailId: string;
  employeeId: string;
  mobileNo: number;

  constructor(e, i, m) {
    this.emailId = e;
    this.employeeId = i;
    this.mobileNo = m;
  }
}